import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

function NavBar() {
  const location = useLocation();
  //console.log(location.pathname); // e.g., /products
  //console.log(location.search);   // e.g., ?category=electronics
  //console.log(location.hash);    // e.g., #details

  const [activePage, setActivePage] = useState(location);

  useEffect( () => {
    
    switch(location.pathname){
      case "/" :  navUnderline('#homeNav'); break;
      case "/game" :  navUnderline('#gameNav'); break;
      case "/garden" :  navUnderline('#gardenNav'); break;
      case "/info" :  navUnderline('#infoNav'); break;
      case "/shop" :  navUnderline('#merchNav'); break;
      case "/story" :  navUnderline('#storyNav'); break;
      case "/tickets" :  navUnderline('#ticketsNav'); break;
      default : navUnderline('#homeNav'); break;
    }

    setActivePage(location)

  }, [location])

  const navUnderline = (navButton) => {
    if( document.querySelector('.navUnderlined') ){
      document.querySelector('.navUnderlined').classList.toggle('navUnderlined');
    }
    document.querySelector(navButton).classList.toggle('navUnderlined');
  }

  return (
    <div className='nav-bar'>
      <div className='nav-bar-links'>
        <a href='/' id="homeNav">Noise Star</a>
        {/*<a href='/story' id="storyNav">Story</a>*/}
        <a href='/game' id="gameNav">Game</a>
        <a href='/shop' id="merchNav">Shop</a>
        <a href='/tickets' id="ticketsNav">Tickets</a>
        {/*<a href='/info' id="infoNav">Info</a> *}
        {/*<a href='/garden' id="gardenNav">?</a> */}
      </div>
    </div>
  );
}

export default NavBar;
